import { inject, Injectable } from '@angular/core'
import { ResourceJSON, ResourceQueryJSON } from '@monorepo/next-lab'
import { MongoStorageService } from './mongo-storage.service'

@Injectable({ providedIn: 'root' })
export class ResourceService {
  private readonly mongoStorageService = inject(MongoStorageService)

  async getAppConfiguration(appId: string): Promise<ResourceJSON | null> {
    const resourceQuery: ResourceQueryJSON = {
      appId,
      resourceType: 'configuration',
      returnMetadataOnly: false,
      maxResults: 1,
    }
    const configurations = await this.mongoStorageService.queryResourcesPromise(resourceQuery, false)
    return configurations[0]
  }
}
